var map = {
	"./0.png": 549487,
	"./1.png": 510470,
	"./2.png": 808029,
	"./3.png": 374996,
	"./4.png": 324907,
	"./5.png": 103778,
	"./6.png": 959865,
	"./7.png": 953616,
	"./8.png": 573527,
	"./9.png": 627950,
	"./dian.png": 45355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 649398;